import { useState } from 'react';
import type { EmailData } from './EmailListItem';
import styles from './RoutingAlert.module.css';

interface StateRep {
  state: string;
  rep: string;
  territories: string;
}

interface RoutingAlertProps {
  email: EmailData & {
    customer?: {
      name: string;
    };
    shipping?: {
      address: string;
      state: string;
    };
    stateReps?: StateRep[];
  };
}

const RoutingAlert: React.FC<RoutingAlertProps> = ({ email }) => {
  const [selectedRep, setSelectedRep] = useState<string | null>(
    email.stateReps?.find(r => r.state === email.shipping?.state)?.rep || null
  );

  if (!email.stateReps || !email.shipping) {
    return null;
  }

  return (
    <div className={styles.alert}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
        </div>
        <div className={styles.title}>State-Based Assignment Required</div>
      </div>
      <p className={styles.description}>
        <strong>{email.customer?.name || email.from}</strong> ships to multiple states. Select rep based on destination:
      </p>
      <div className={styles.shipTo}>
        <strong>Ship To:</strong> {email.shipping.address.replace(/\n/g, ', ')}
      </div>
      <div className={styles.options}>
        {email.stateReps.map((rep, index) => {
          const isRecommended = email.shipping?.state === rep.state;
          return (
            <label
              key={index}
              className={`${styles.option} ${selectedRep === rep.rep ? styles.selected : ''}`}
            >
              <input
                type="radio"
                name="stateRep"
                value={rep.rep}
                checked={selectedRep === rep.rep}
                onChange={() => setSelectedRep(rep.rep)}
              />
              <div>
                <div>
                  <span className={styles.repName}>{rep.rep}</span>
                  {isRecommended && (
                    <span className={styles.recommended}>(Recommended)</span>
                  )}
                </div>
                <div className={styles.territories}>{rep.territories}</div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default RoutingAlert;
